import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@cambridgeassessment/cambridge-ui';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/ban-types
type Props = {
  keyId: any;
  expand: boolean;
  testid: string;
  summaryData: string;
  onExpand(expandAll: boolean, expand: boolean, key: any);
  children;
};
const RolesExpandable: React.FC<Props> = ({
  keyId,
  expand,
  testid,
  summaryData,
  onExpand,
  children,
}) => {
  return (
    <Accordion
      defaultExpanded
      expanded={expand}
      key={keyId}
      data-testid={`${testid}-accordion`}
      onClick={() => onExpand(false, expand, summaryData)}
      TransitionProps={{ unmountOnExit: true }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${testid}-content`}
        id={`${testid}-header`}
        data-testid={`${testid}-header`}
      >
        <Box data-testid={`${testid}-box`}>
          <Typography variant="subtitle1" data-testid={`${testid}-typography`}>
            {summaryData}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails
        data-testid={`${testid}-accordiondetails`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default RolesExpandable;
